import FeatureFlagsModule from "./feature_flags.module";

import "./feature_decisions.provider";
import "./is_feature_enabled.directive";
import "./flag-keys";

export default FeatureFlagsModule;
